import * as React from 'react';
import { Container } from 'flux/utils';
import EventTracking from 'lib/EventTracking';

import Link from 'components/Link';
import Image from 'components/Image';
import Text from 'components/Text';
// @ts-ignore
import UnreadStore from 'stores/UnreadStore';
import { NavigationListGroupItemBadge } from 'components/NavigationList/NavigationListGroupItem';

import { NavigationList_me_navigationSections_items } from 'queries/__generated__/NavigationList';

import './styles/NavigationListCoachingStreamItem.scss';

type Props = {
  coachingStream: NavigationList_me_navigationSections_items;
};

type State = {
  unreadCount: number;
};

const eventPrefix = 'coaching.nav_list.coaching_stream_item';

class NavigationListCoachingStreamItem extends React.Component<Props, State> {
  state = {
    unreadCount: 0,
  };

  static getStores() {
    return [UnreadStore];
  }

  static calculateState(state: State, props: Props) {
    const { coachingStream } = props;
    if (coachingStream.__typename !== 'CoachingStream') {
      return { unreadCount: 0 };
    }
    return {
      unreadCount: UnreadStore.getChatStreamUnreadCount(coachingStream.uuid),
    };
  }

  componentDidMount() {
    this.track('view');
  }

  hasUnreads() {
    return this.state.unreadCount > 0;
  }

  track(eventKey: string) {
    EventTracking.trackKey(`${eventPrefix}.${eventKey}`);
  }

  renderBadge() {
    return (
      this.hasUnreads() && <NavigationListGroupItemBadge unreadCount={this.state.unreadCount} />
    );
  }

  render() {
    const { coachingStream } = this.props;
    if (coachingStream.__typename !== 'CoachingStream') {
      console.warn(coachingStream);
      console.error(
        'NavigationListCoachingStreamItem - tried to render with an item that was not a CoachingStream'
      );
      return null;
    }

    const { uuid: streamUuid } = coachingStream;
    if (!streamUuid) {
      console.debug(this.props);
      console.error('NavigationListCoachingStreamItem - stream without uuid');
      return null;
    }

    return (
      <li className="NavigationListCoachingStreamItem">
        <Link
          data-test="coaching-stream-nav-link"
          eventKey={`${eventPrefix}.click`}
          color="inherit"
          activeClassName="active"
          to={`/coaching/messages/${streamUuid}`}
          className="NavigationListCoachingStreamItem-link">
          <div className="NavigationListCoachingStreamItem-container">
            <Image width={16} className="NavigationListCoachingStreamItem-avatar" src="" />
            <Text
              data-test="coaching-stream-title-text"
              className="NavigationListCoachingStreamItem-name"
              truncate
              weight={this.hasUnreads() ? 'semibold' : 'normal'}>
              {coachingStream.displayName}
            </Text>
            {this.renderBadge()}
          </div>
        </Link>
      </li>
    );
  }
}

export { NavigationListCoachingStreamItem };
export default Container.create(NavigationListCoachingStreamItem, {
  withProps: true,
  pure: false,
});
